export default __webpack_public_path__ + "static/media/le_croise3.f0f41961.jpg";